import React, {Component} from 'react';
import './Bottom.css';
import logo_img from "../img/amosova_logo.jpg";
import {Link, NavLink} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFacebookF, faFacebookSquare, faInstagram, faVk, faYoutube} from "@fortawesome/free-brands-svg-icons";

class Bottom extends Component {
    render() {
        return (
            <div className='page-bottom'>
                <div className='page-bottom-wrapper'>
                    <div className='page-logo'>
                        <img src={logo_img}/>
                    </div>
                    <div className='social-links text-center'>
                        <a className='text-white fa-2x' target='_blank'
                                 href='https://www.facebook.com/eleonoraamosova'><FontAwesomeIcon className='facebook'
                                                                                                icon={faFacebookF}/></a>
                        <a href={Link} className='text-white fa-2x' target='_blank'
                                 href='https://vk.com/eleonoraamosova'><FontAwesomeIcon className='vkontakte'
                                                                                      icon={faVk}/></a>
                        <a href={Link} className='text-white fa-2x' target='_blank'
                                 href='https://www.instagram.com/eleonoraamosova/'><FontAwesomeIcon className='instagram'
                                                                                                  icon={faInstagram}/></a>

                        <a href={Link} className='text-white fa-2x' target='_blank'
                                 href='https://www.youtube.com/channel/UCin4RAG4MICAtsepx2QbJMg'><FontAwesomeIcon className='youtube'
                                                                                            icon={faYoutube}/></a>
                    </div>
                </div>
            </div>
        );
    }
}

export default Bottom;


// WEBPACK FOOTER //
// ./src/components/Bottom.js